import { useCallback } from "react";

import useSocketEvent from "Hooks/useSocketEvent";
import { publishRequestCountsFromSocket } from "Hooks/useRequestCountsSync";

/**
 * RequestCountsSocketBridge
 * ---
 *
 * Backoffice socket'i client'ın `{clientSlug}_private` odasına join
 * olduktan sonra server `client_new_request_counts` event'i ile
 * yatırım / çekim / bonus sayaçlarını push'luyor. Bu bileşen, event'i
 * tek bir noktadan dinleyip payload'ı `useRequestCountsSync`'in
 * beslediği global event bus'a publish'liyor — böylece sidebar +
 * finans sayfalarındaki tüm `useRequestCountsSync` tüketicileri
 * tek socket abonesinden besleniyor (N×N callback patlaması olmuyor).
 *
 * `BackofficeSocketProvider`'ın altına **tek sefer** mount edilir.
 *
 * NOT: `socketConnectedForCounts` polling flag'i artık burada değil,
 * doğrudan `BackofficeSocketContext`'teki room-join lifecycle'ında
 * yönetiliyor (flag yalnızca odaya katıldıktan sonra true oluyor).
 */
const RequestCountsSocketBridge = () => {

  /**
   * Server'dan gelen push'u global event bus'a aktar.
   * useSocketEvent'in gereksiz unmount/remount tetiklememesi için
   * callback referansını sabit tutuyoruz.
   */
  const handlePush = useCallback((data: any) => {
    publishRequestCountsFromSocket(data);
  }, []);

  useSocketEvent("client_new_request_counts", handlePush);

  return null;

};

export default RequestCountsSocketBridge;
